import '../../css/views/home.css';
import 'swiper/css/bundle';
import { Text, Image } from '../utils/dom';
console.log("hi homepage");
var items = Array.from(document.getElementById("carousel").children);
// Create duplicates
const carousel = document.getElementById("carousel");
// Prepend duplicates in reverse order
const prependItems = items.map(item => Text("h1", item.innerHTML)).reverse();
prependItems.forEach(item => carousel.prepend(item));
// Append duplicates in original order
items.forEach(item => carousel.append(Text("h1", item.innerHTML)));
// Update items to include new duplicates
items = Array.from(carousel.children);
for (var item of items) {
    item.style.width = item.clientWidth * 1.1 + "px";
}
const originalItemsCount = items.length / 3; // Total number of original items
const visibleItemsCount = originalItemsCount; // Number of visible items in the middle
// Calculate start and end range based on original items
const startRange = Math.floor(originalItemsCount / 2);
const endRange = startRange + visibleItemsCount;
var activeIndex = startRange + Math.round(Math.random() * 5 - 1); // Start in the middle
function transitionToItem(index) {
    items.forEach(item => item.classList.remove("active"));
    // @ts-ignore
    items[index].classList.add("active");
    // Calculate totalWidth by summing up the width of each item
    let totalWidth = 0;
    items.forEach(item => {
        totalWidth += item.offsetWidth;
    });
    // Ensure the carousel width is correctly set
    carousel.style.width = `${totalWidth}px`;
    // Calculate transformX for the current activeIndex
    let transformX = 0;
    // @ts-ignore
    for (let i = 0; i < index; i++) {
        transformX -= items[i].offsetWidth;
    }
    // Apply the transformation
    carousel.style.transform = `translateX(${transformX}px)`;
}
var lastImg;
lastImg = null;
function doswitch() {
    // Check if we need to move to the next item
    if (activeIndex >= endRange - 1) {
        activeIndex++;
        transitionToItem(activeIndex);
        // Update the active class to include the duplicate of the first item
        // Move to the start position after a short delay
        setTimeout(() => {
            carousel.classList.add("disable-animation");
            // Jump back to the first item instantly
            activeIndex = startRange;
            transitionToItem(activeIndex);
            // Re-enable transitions and animate to the new position
            setTimeout(() => {
                carousel.classList.remove("disable-animation");
            }, 100);
        }, 1500); // Delay matches the transition duration
    }
    else {
        // Normal case: transition to the next item
        activeIndex++;
        transitionToItem(activeIndex);
    }
    if (lastImg != null)
        lastImg.classList.remove("next");
    var img = Image(`/public/img/home/${items[activeIndex].innerText}.png`, "", false);
    document.getElementById("image-container").appendChild(img);
    img.classList.add("next");
    setTimeout(() => {
        if (lastImg != null)
            lastImg.remove();
        lastImg = img;
    }, 1000);
    img.addEventListener("load", () => {
        document.body.classList.add("loaded");
        setTimeout(() => {
            carousel.classList.add("loaded");
        }, 150);
    });
}
doswitch();
setInterval(doswitch, 4000);
